import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_DOCUMENTO } from '../../data.const';
import {
  setCurrentDocumentoAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrieveDocumentoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_DOCUMENTO),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_DOCUMENTO}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ documentoLoader: true })),
        defer(() =>
          from(
            request({ path: `documento/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_DOCUMENTO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentDocumentoAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_DOCUMENTO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ documentoLoader: false }))
      );
    })
  );

export default retrieveDocumentoEpic;
